module.exports = __webpack_public_path__ + "img/winkelgebieden.ff1fb28b.png";